import React from 'react';

const Footer = () => {
    return (
        <div>
            {/* <!-- Footer 1 --> */}
            <footer className="footer">
                <div className="footer_above">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer_widget news_widget">
                                    <h5 className="widget_title">Latest News</h5>
                                    <ul className="most_read">
                                        <li className="most_read_item">
                                            <div className="most_read_content">
                                                <h6>August 06, 2022</h6>
                                                <h5><a>Bread & Jam Fusion</a></h5>
                                            </div>
                                        </li>
                                        <li className="most_read_item">
                                            <div className="most_read_content">
                                                <h6>August 06, 2022</h6>
                                                <h5><a>How to start food Blogging</a></h5>
                                            </div>
                                        </li>
                                        <li className="most_read_item">
                                            <div className="most_read_content">
                                                <h6>August 06, 2022</h6>
                                                <h5><a>15 Amazing Tips to keep food fresh</a></h5>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer_widget center_widget">
                                    <div className="logo_footer">
                                        <a href="/">
                                            <img src="images/logo2.svg" alt="hungrybuzz" />
                                        </a>
                                        <p>Lorem ipsum dolor sit amet, consectetur adipisc
                                            do eiusmod tempor incididunt</p>
                                    </div>
                                    <div className="footer_social">
                                        <ul className="bottom_social">
                                            <li className="facebook"><a><span>FB</span> Facebook</a></li>
                                            <li className="instagram"><a><span>IN</span> Instagram</a></li>
                                            <li className="youtube"><a><span>YT</span> YouTube</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-6">
                                <div className="footer_widget widget_payment">
                                    <h5 className="widget_title">Payment Procedure</h5>
                                    <p>Lorem ipsum dolor sit amet consectetur
                                        mod tempor indidunt ut labore et dolore
                                        magna aliqua. </p>
                                    <p>Mod tempor indidunt ut labore </p>

                                    <div className="paymethod">
                                        <a><img src="images/payment1.svg" alt="" /></a>
                                        <a><img src="images/payment2.svg" alt="" /></a>
                                        <a><img src="images/payment3.svg" alt="" /></a>
                                        <a><img src="images/payment4.svg" alt="" /></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_bottom">
                    <div className="container">
                        <div className="footer_bottom_inner">
                            <div className="copyright">
                                <p> &copy; All rights reserved to <a>WPThemeBooster</a></p>
                            </div>
                            <div className="totop">
                                <a href="#"><i className="ion-ios-arrow-up"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default Footer;